import { StandardMaterial } from "@babylonjs/core";
import { InputsNavigationController } from "core/map";
import { VirtualDisplay, VirtualDisplayInputsSource } from "../../display";
import { WebMapTexture } from "../../materials";
export class MapDisplay extends VirtualDisplay {
    constructor(name, dimension, options, scene) {
        options = options ?? WebMapTexture.OptionsHD();
        super(name, dimension, options, scene);
        this._content = this._createTextureMap(name, options, this.getScene());
        this.node.material = this._createMaterial(name, this._content, this.getScene());
        this._source = new VirtualDisplayInputsSource(this);
        this._controller = new InputsNavigationController(this._source, this._content?.map, { invertY: true });
    }
    get content() {
        return this._content;
    }
    get map() {
        return this._content.map;
    }
    _createTextureMap(name, options, scene) {
        options = options ?? WebMapTexture.OptionsHD();
        return new WebMapTexture(this._createTextureName(name), options, scene);
    }
    _createMaterial(name, texture, scene) {
        const material = new StandardMaterial(this._createMaterialName(name), scene);
        material.diffuseTexture = texture;
        return material;
    }
    _createMaterialName(name) {
        return `${name}_${MapDisplay.MaterialSuffix}`;
    }
    _createTextureName(name) {
        return `${name}_${MapDisplay.TextureSuffix}`;
    }
}
MapDisplay.MaterialSuffix = "material";
MapDisplay.TextureSuffix = "texture";
//# sourceMappingURL=map.display.virtual.js.map